import { render, staticRenderFns } from "./DealershipAppointD288Success.vue?vue&type=template&id=bfd04f4a&"
import script from "./DealershipAppointD288Success.vue?vue&type=script&lang=js&"
export * from "./DealershipAppointD288Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports